import type { Listing, Profile, PromotionCampaign, SupplyStore } from "./terra-boa-data";

function timestamp(value: unknown): number | undefined {
  let date: Date | undefined;
  if (value instanceof Date) date = value;
  else if (typeof value === "string" && value !== "Agora") date = new Date(value);
  else if (value && typeof value === "object" && "toDate" in value && typeof value.toDate === "function") date = value.toDate();
  else if (value && typeof value === "object" && "seconds" in value && typeof value.seconds === "number") return value.seconds * 1000;
  const result = date?.getTime();
  return result !== undefined && Number.isFinite(result) ? result : undefined;
}

export function compareStoreProducts(sponsored: boolean) {
  const insertedAt = (listing: Listing) => Number(/^lst-(\d+)$/.exec(listing.id)?.[1]) || timestamp(listing.createdAt) || 0;
  return (left: Listing, right: Listing) => (sponsored ? Number(Boolean(right.onSale)) - Number(Boolean(left.onSale)) : 0)
    || insertedAt(right) - insertedAt(left) || left.id.localeCompare(right.id);
}

export function compareStoreTechnicians(left: Profile & { updatedAt?: unknown }, right: Profile & { updatedAt?: unknown }) {
  // Technical profiles receive updatedAt when their store affiliation is approved.
  const joinedAt = (profile: Profile & { updatedAt?: unknown }) => timestamp(profile.updatedAt) ?? timestamp(profile.since) ?? Number.MAX_SAFE_INTEGER;
  return joinedAt(left) - joinedAt(right) || left.id.localeCompare(right.id);
}

export function storeAdvertisements(campaigns: PromotionCampaign[], store: SupplyStore, today: string) {
  return campaigns.filter((campaign) => campaign.storeId === store.id && campaign.active
    && campaign.startsOn <= today && campaign.endsOn >= today
    && (!campaign.ownerProfileId || Boolean(campaign.type === "popup" ? store.advertising?.allowPopup : store.advertising?.allowOptIn)))
    .sort((left, right) => (timestamp(right.createdAt) ?? 0) - (timestamp(left.createdAt) ?? 0) || left.id.localeCompare(right.id));
}
